import DiscountSummaryError from './DiscountSummaryError';
class DiscountSummaryInvalidPropertyID extends DiscountSummaryError {
    propertyId;
    constructor(propertyId, options) {
        super('INVALID_CROWDFUNDING_PROPERTY_ID', options);
        this.propertyId = propertyId;
    }
}
export default DiscountSummaryInvalidPropertyID;
